<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="reply"
    item-key="id"
    show-select
  >
    <template v-slot:top>
      <v-dialog v-model="dialog" persistent max-width="390">
        <template v-slot:activator="{ on, attrs }">
          <div class="pb-4">返信</div>
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            チェックした返信を削除する
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">確認</v-card-title>
          <v-card-text>
            選択された返信を削除します。よろしいですか？
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="deleteReply">OK</v-btn>
            <v-btn color="green darken-1" text @click="dialog = false">キャンセル</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>  
  </v-data-table>
</template>

<script>
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        dialog: false,
        reason: '11',
        db: null,
        selected: [],
        headers: [
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'id',
          },
          { text: 'コメント日時', value: 'createdAt' },
          { text: '利用者', value: 'userName' },
          { text: '予想タイトル', value: 'predictionTitle' },
          { text: '返信', value: 'content' },
          { text: 'いいね', value: 'likeCount' },
          { text: '通報', value: 'badCount' },
        ],
        reply: []
      }
    },
    methods: {
      deleteReply () {
        let promises = []
        for (const row of this.selected) {
          let promise = this.$fb.deleteDoc(this.$fb.doc(
            this.$fb.firestore,
            'prediction',
            row.predictionId,
            'comments',
            row.commentId,
            'reply',
            row.id))
          promises.push(promise)
        }
        Promise.all(promises).then(() => {
          location.reload()
        }).catch (error => {
          console.error(error)
        })
      },
      getReply () {
        this.$fb.getDocs(this.$fb.query(this.$fb.collectionGroup(this.$fb.firestore, 'reply')
          .withConverter(this.replyConverter),
          this.$fb.orderBy('created_at', 'desc'),
          this.$fb.limit(1000)))
          .then(replySnap => {
            this.reply = []
            replySnap.forEach(replyDoc => {
              let reply = replyDoc.data()
              reply.likeCount = reply.like?.length ?? 0
              reply.badCount = reply.bad?.length ?? 0
              reply.commentId = replyDoc.ref.parent.parent.id
              reply.predictionId = replyDoc.ref.parent.parent.parent.parent.id
              const userPromise = this.$fb.getDoc(this.$fb.doc(
                this.$fb.firestore,
                'users',
                reply.userId)
                .withConverter(this.userConverter))
              const predictionPromise = this.$fb.getDoc(this.$fb.doc(
                this.$fb.firestore,
                'prediction',
                reply.predictionId)
                .withConverter(this.predictionConverter))
              const promiseArray = [
                userPromise,
                predictionPromise,
              ]
              Promise.all(promiseArray).then(resultArray => {
                const userDoc = resultArray[0]
                const predictionDoc = resultArray[1]
                reply.userName = userDoc.data()?.nickname
                reply.predictionTitle = predictionDoc.data().predictionTitle
                this.reply.push(reply)
              })
            })
          }).catch(error => {
            console.error(error)
            this.reply = []
          })
      },
    },
    created () {
      this.getReply()
    }
  }
</script>